import userActionTypes from "./user.types";
import { refreshReduxStore } from "../../utils/generalFunctions";

const INITIAL_STATE = {
  authenticationData: null,
  isVerified: false,
  error: null,
  loading: false,
  mfaStatus: false,
  userLoader: false,
  qrCodeData: null,
  qrCodeLoader: false,
  userName: "",
  userEmail: "",
  userPermission: 0,
  corpDetails: {
    corpName: "",
    corpId: null,
  },
};

const userReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case userActionTypes.SET_USER_NAME: {
      return {
        ...state,
        userName: action.payload,
      };
    }
    case userActionTypes.SET_USER_PERMISSION: {
      return {
        ...state,
        userPermission: action.payload,
      };
    }
    case userActionTypes.SET_USER_EMAIL: {
      return {
        ...state,
        userEmail: action.payload,
      };
    }
    case userActionTypes.SET_ACCESS_TOKEN:
      return {
        ...state,
        authenticationData: {
          ...state.authenticationData,
          access_token: action.payload,
        },
      };
    case userActionTypes.SIGNIN_START:
    case userActionTypes.SIGNOUT_START:
    case userActionTypes.START_LOADING:
      return {
        ...state,
        loading: true,
      };
    case userActionTypes.SIGNIN_SUCCESS:
      return {
        ...state,
        authenticationData: action.payload,
        error: null,
        loading: false,
      };
    case userActionTypes.SIGNIN_FAILURE:
    case userActionTypes.SIGNOUT_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case userActionTypes.SIGNOUT_SUCCESS:
      return {
        ...INITIAL_STATE,
      };
    case userActionTypes.STOP_LOADING:
      return {
        ...state,
        loading: false,
      };
    case userActionTypes.SET_IS_VERIFIED:
      return {
        ...state,
        isVerified: action.payload,
      };
    case userActionTypes.SET_USER_LOADER:
      return {
        ...state,
        userLoader: action.payload,
      };

    case userActionTypes.SET_MFA_STATUS:
      return {
        ...state,

        mfaStatus: action.payload,
      };

    case userActionTypes.SET_QR_CODE_DATA:
      return {
        ...state,

        qrCodeData: action.payload,
      };

    case userActionTypes.SET_QR_CODE_LOADER:
      return {
        ...state,

        qrCodeLoader: action.payload,
      };
    case userActionTypes.SET_CORP_DETAILS:
      return {
        ...state,
        corpDetails: {
          corpName: action.payloadName,
          corpId: action.payloadId,
        },
      };
      case userActionTypes.RESET_REDUX:
        let key = refreshReduxStore(state, INITIAL_STATE);
        return {
            ...key,
      };
    default:
      return state;
  }
};

export default userReducer;
